module.exports = __webpack_public_path__ + "media/img/pages/companies/ey-7862a740db977cd45750f4a774ba53b5.png";